import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  guideScreen4: {
    position: "absolute",
    top: "20%",
    left: "32%",
    height: "1px",
    width: "1px",
    background: "rgba(12, 13, 33, 0.8)",
  },
  btnStyle: {
    marginTop: "-0.5rem",
    opacity: 0.2,
    zIndex: 9999,
    background: "rgba(240, 240, 240, 0.25)",
    borderRadius: "12px",
    backdropFilter: "blur(24px)",
    fontFamily: "Titillium Web",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    textTransform: "capitalize",
    boxShadow: "none",
    "& div#location-select": {
      fontSize: "16px",
      padding: "12px 16px !important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "24px",
      padding: "2px",
    },
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2) !important",
      opacity: 1,
    },
  },
  positionComponent: {
    position: "absolute",
    top: 0,
    width: "100%",
  },
  logoStyle: {
    opacity: 0.5,
    "&:hover": {
      opacity: 1,
    },
  },
  audioStyle: {
    opacity: 0.2,
    zIndex: 9999,
    background: "rgba(240, 240, 240, 0.25)",
    borderRadius: "10px",
    backdropFilter: "blur(24px)",
    fontFamily: "Titillium Web",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    textTransform: "capitalize",
    boxShadow: "none",
    width: "1.8rem",
    height: "1.7rem",
    padding: "0.7rem",
    marginTop: "-0.5rem",
    "& div#location-select": {
      fontSize: "16px",
      padding: "12px 16px !important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "15px",
      padding: "2px",
    },
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2) !important",
      opacity: 1,
    },
  },
});
